<template>
  <v-snackbar
    top
    v-model="snackbar.visible"
    :color="snackbar.color"
    :timeout="snackbar.timeout"
  >
    <v-flex text-xs-center>
      {{ snackbar.text }}
    </v-flex>
  </v-snackbar>
</template>

<script>

export default {
  computed: {
    snackbar () {
      return this.$store.state.snackbar
    }
  }
}
</script>
